import { cn } from '@/lib/utils';

export interface PhotoFilterProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export function PhotoFilter({
  size = 20,
  width,
  height,
  fill = '#061A61',
  className,
  ...props
}: PhotoFilterProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 15 15"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M13.3333 5.83333V13.3333H1.65V1.66667H9.15V0H1.66667C0.75 0 0 0.75 0 1.66667V13.3333C0 14.25 0.75 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V5.83333H13.3333ZM10.8833 4.11667L11.6667 5.83333L12.45 4.11667L14.1667 3.33333L12.45 2.55L11.6667 0.833333L10.8833 2.55L9.16667 3.33333L10.8833 4.11667ZM7.5 4.16667L6.45833 6.45833L4.16667 7.5L6.45833 8.54167L7.5 10.8333L8.54167 8.54167L10.8333 7.5L8.54167 6.45833L7.5 4.16667Z"
        fill={fill}
      />
    </svg>
  );
}
